module.exports = __webpack_public_path__ + "static/media/CircularStd-BookItalic.6ba855cf.eot";